import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputLabel from "@material-ui/core/InputLabel";
// core components
import Table from "../../components/Table/VendorTeamTable.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import CustomInput from "../../components/CustomInput/CustomInput.jsx";
import Button from "../../components/CustomButtons/Button.jsx";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardAvatar from "../../components/Card/CardAvatar.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import CardFooter from "../../components/Card/CardFooter.jsx";
import { spinnerService } from "@chevtek/react-spinners";
import imgPlaceholder from "../../assets/img/person-placeholder.jpg";
import Icon from "@material-ui/core/Icon";
import Avatar from "@material-ui/core/Avatar";
import {
  listCustomerTeams,
  getVendor,
  getCustomer
} from "../../graphql/queries";

import * as actionTypes from "../../redux/actions";

import _ from "lodash";
import { flowRight } from "lodash";

import { toast } from "react-toastify";
import Input from "@material-ui/core/Input";

import { Auth, API, graphqlOperation, Storage } from "aws-amplify";
import awsConfigSettings from "../../aws-exports";
import CognitoIdentityServiceProvider from "aws-sdk/clients/cognitoidentityserviceprovider";
import gql from "graphql-tag";
import { withApollo } from "react-apollo";
import { createCustomerTeam } from "../../graphql/mutations";
import { Link } from "react-router-dom";

import { connect } from "react-redux";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  }
};

class ListTeam extends Component {
  constructor(props) {
    super(props);
    this.state = {
      empType: null,
      empName: null,
      phoneNo: null,
      email: null,
      password: null,
      confirmPassword: null,
      accountStatus: null,
      dataFetching: true,
      notes: "",
      username: null,
      userId: "",
      customer: {},
      teamMembers: [],
      errors: {
        cognito: false,
        blankfield: false,
        passwordmatch: false
      },
      emailValidate: true,
      emailFeedback: null
    };
    //this.handleSubmit = this.handleSubmit.bind(this);
  }
  async componentDidMount() {
    this.getData();
  }

  getData = async () => {
    spinnerService.show("mySpinner");
    const { client, user, customerTeam } = this.props;
    const self = this;
    let empType = this.props.match.params.type;
    this.setState({ empType });

    let data = {};
    let isFetched = false;
    if (
      customerTeam === undefined ||
      customerTeam === "" ||
      customerTeam === null ||
      customerTeam.length === 0
    ) {
      const custProfile = await client.query({
        query: gql(getVendor),
        fetchPolicy: `network-only`,
        variables: {
          id: user.username
        }
      });
      data = custProfile.data.getVendor.vendorTeam.items;
      isFetched = true;
    } else data = customerTeam;

    let filteredData = data;
    if (empType !== null || empType !== "") {
      filteredData = data.filter(item => {
        return item.empType === empType;
      });
    }

    let userPoolId = awsConfigSettings.aws_user_pools_id;
    let credentials = await Auth.currentCredentials();
    let cognitoClient = await Promise.resolve(
      new CognitoIdentityServiceProvider({
        apiVersion: "2016-04-18",
        credentials: Auth.essentialCredentials(credentials),
        region: "us-east-2"
      })
    );
    if (filteredData && filteredData.length > 0) {
      await filteredData.map(async dt => {
        let params = {
          UserPoolId: userPoolId /* required */,
          Username: dt.id /* required */
        };
        await cognitoClient.adminGetUser(params, function(err, data) {
          if (data !== null && err === null) {
            
            dt.status = data.Enabled ? "Enabled" : "Disabled";
            self.setState({ teamMembers: filteredData }, () => {
              self.setState({ dataFetching: false });
              spinnerService.hide("mySpinner");
            });
          } else {
            
            spinnerService.hide("mySpinner");
          }
        });
      });
    } else {
      spinnerService.hide("mySpinner");
    }
    isFetched && this.props.storeTeam(data);
  };

  clearErrorState = () => {
    this.setState({
      errors: {
        cognito: false,
        blankfield: false,
        passwordmatch: false
      }
    });
  };
  checkValidate = () => {
    let { passwordValidate, phoneValidated } = this.state;
    if (!passwordValidate) {
      document.getElementById("password").focus();
      return false;
    } else if (!phoneValidated) {
      document.getElementById("phoneNo").focus();
      return false;
    } else {
      return true;
    }
  };
  loadData = async (user, reload) => {
    spinnerService.show("mySpinner");

    const client = this.props.client;

    // const { editCustomer } = this.context;
    if (user) {
      const userDetails = await client.query({
        query: gql(getCustomer),
        fetchPolicy: `network-only`,
        variables: { id: user.username, limit: 1000 }
      });

      if (userDetails.data.getCustomer) {
        var selectVeh = new Array();
        var data = {
          customer: userDetails.data.getCustomer,
          teamMembers: userDetails.data.getCustomer.customerTeam.items
        };
        //this.props.addTeamMember(data);
        this.setState(data);
        /**/
      }
    }

    spinnerService.hide("mySpinner");
  };
  onInputChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };

  render() {
    const { customer, teamMembers } = this.state;
    const { classes, client, user } = this.props;
    return (
      <div>
        <Card>
          <CardHeader color="primary">
            <h4 className={classes.cardTitleWhite}>
              List of {this.state.empType}
            </h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              {" "}
              <GridItem xs={12} sm={12} md={12}>
                <div style={{ float: "right" }}>
                  <Link
                    style={{
                      padding: "10px",
                      marginLeft: "15px",
                      color: "white",
                      backgroundColor: "#5BB860"
                    }}
                    to={{
                      pathname:
                        "/profile/cteam/" + this.props.match.params.type,
                      client: { client }
                    }}
                  >
                    Add New Employee
                  </Link>
                </div>
                {!this.state.dataFetching && (
                  <Table
                    tableHeaderColor="primary"
                    tableHead={[
                      "Name",
                      "Username",
                      "Email",
                      "Phone",
                      "Notes",
                      "A/c Status"
                    ]}
                    tableData={teamMembers}
                    client={client}
                    onMount={() => this.getData()}
                  />
                )}
              </GridItem>
            </GridContainer>
            <div style={{ float: "right", marginTop: 20 }}>
              <Button
                color="secondary"
                onClick={() => this.props.history.push("/profile")}
              >
                Back
              </Button>
            </div>
          </CardBody>{" "}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.config.user,
    client: state.config.client,
    profile: state.config.profile,
    customerTeam: state.config.customerTeam,
    userChoice: state.config.userChoice
  };
};
const mapDispatchToProps = dispatch => {
  return {
    storeTeam: data => dispatch(actionTypes.storeTeam(data)),

    storeUserChoice: data => dispatch(actionTypes.storeUserChoice(data))
  };
};
export default ListTeam = connect(
  mapStateToProps,
  mapDispatchToProps
)(flowRight(withApollo)(withStyles(styles)(ListTeam)));



// WEBPACK FOOTER //
// ./src/vendors/profile/ListTeam.jsx